module.exports = __webpack_public_path__ + "static/media/Суяргулова Э.Э..450017a2.pdf";